export default __webpack_public_path__ + "static/media/start_right.97fb87a9.png";